import axios from "axios";
import { toast } from "react-toastify";

axios.defaults.baseURL = "https://staging-verify-api.dev.aquilasoftwares.com/api/v1";

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("jwt_token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const responseBody = (response) => response.data;

const paginatedResponseBody = (response) => {
  const headers = response.headers;
  const paginationHeader = headers["pagination"] || headers["Pagination"];

  let pagination = null;

  if (paginationHeader) {
    try {
      pagination = typeof paginationHeader === "string" ? JSON.parse(paginationHeader) : paginationHeader;
    } catch (error) {
      toast.error(error, {
        position: "top-right",
      });
    }
  }

  return {
    data: response.data,
    pagination: pagination,
  };
};

export const api = {
  get: (url, config) => axios.get(url, config).then(responseBody),
  getPaginated: (url, config) => axios.get(url, config).then(paginatedResponseBody),
  post: (url, body) => axios.post(url, body).then(responseBody),
  put: (url, body) => axios.put(url, body).then(responseBody),
  patch: (url, body) => axios.patch(url, body).then(responseBody),
  delete: (url) => axios.delete(url).then(responseBody),
  postForm: async (url, file) => {
    const formData = new FormData();
    formData.append("File", file);
    const response = await axios.post(url, formData, {
      headers: {
        "Content-type": "multipart/form-data",
      },
    });
    return responseBody(response);
  },
};
